export default {
    CustomerList: {
        ChooseCustomer: 'Vyberte zákazníka',
    },

    Customer: {
        SafesOnline: 'Pripojené trezory',
        CurrentBalance: 'Aktuálny zostatok',
        DailySales: 'Denná tržba',
        ActiveWarnings: 'Aktívne upozornenie',
        Of: 'z',
        In: 'V',
        Branches: 'POBOČKY'
    },

    Branch: {
        ExportTransactions: "Exportovať transakcie",
        ManageOperators: "Upraviť operátorov",
        ShowOnMap: "Zobraziť na mape",
        CurrentBalance: "Aktuálny zostatok",
        DailySales: 'Denná tržba',
        MainCurrency: 'Hlavná Mena',
        TransactionDays: 'Transakčné dni'
    },

    BranchList: {
        Name: 'Názov',
        Status: 'Status',
        BalanceAmount: 'Zostatok',
        BalanceCurrency: 'Mena zostatku',
        LastBalance: 'Aktualizované',
        Branches: 'Pobočky',
    },

    BranchListFilter: {
        Branches: 'Pobočky',
        SearchCriteria: 'Hľadám pobočku...',
    },

    Chart: {
        Sales: 'Tržby',
        Pickup: 'Odvod',
        Balance: 'Zostatok',
        Difference: 'Diferencia',
        Confirmed: 'Potvrdená',
        DepositsAndPickups: 'Vklady a výbery',
        NoDataAvailable: 'Žiadne dáta k dispozícii',
        SafebagBalance: 'Zostatok v Safebagu',
        RecyclableBalance: 'Recyklovateľný zostatok',
        ManualDepositBalance: 'Zostatok ručného vkladu',
        OverflowBalance: 'Zostatok prebytku'
    },

    ChartDenominations: {
        Deposited: 'Vloženo',
        Recyclable: 'Recyklovatelné',
        Denominations: 'Hodnoty bankovek',
        NoDataAvailable: 'Žádné'
    },

    ChartTransactionDay: {
        ProcessedSales: 'Zpracovaný vklad',
        UnprocessedSales: 'Nezpracovaný vklad',
        SalesOut: 'Výběr',
        SalesPerHour: 'Tržby za hodinu'
    },

    CustomerHeader: {
        ShowOnMap: 'Zobraziť na mape',
        Branches: 'Pobočky',
        Branch: 'Pobočka',
        ExportTransactions: "Exportovať transakcie"
    },

    DeviceStatus: {
        AllOk: 'Všetko v poriadku',
    },

    DeviceStatusList: {
        Safes: 'Trezory',
    },

    ExportForm: {
        ExportTransactions: 'Exportovať transakcie',
        Cancel: 'Zrušiť',
        Export: 'Export',
        FromDate: 'Od dátumu',
        Time: 'Čas',
        EndDate: 'Do dátumu'
    },

    ForgotPasswordForm: {
        ForgotHeader: 'Zabudli ste svoje heslo?',
        ForgotText: 'Prosím zadajte svoj email a stlačte tlačidlo. Obdržíte email s ďalšími inštrukciami.',
        LoginLink: 'Späť na prihlásenie',
        EmailAddress: 'Emailová adresa',
        Submit: 'Odoslať email',
        ErrorMessage: 'Nebolo možné odoslať Vášu požiadavku na server'
    },

    LoginPage: {
        LoginHeader: 'Vytajte',
        LoginText: 'Nižšie sa prihláste pomocou vášho emailu a hesla.',
        LoginForgot: 'Zabudli ste vaše heslo?',
        Username: 'EMAIL',
        Password: 'HESLO',
        Login: 'Prihlásenie'
    },

    ResetPasswordPage: {
        ResetHeader: 'Obnoviť heslo.',
        ResetText: 'Zadajte vaše nové heslo.'
    },

    Drawer: {
        Dashboard: 'Nástenka',
        SwitchCustomer: 'Prepnúť zákazníka',
        MyProfile: 'Môj profil',
        Logout: 'Odhlásiť'
    },

    OperatorForm: {
        UserId: 'ID užívateľa',
        FirstName: 'Meno',
        LastName: 'Priezvisko',
        Pin: 'PIN',
        Save: 'Uložiť',
        Delete: 'Zmazať',
        Operator: 'Operátora'
    },

    OperatorList: {
        AddOperator: 'Pridať operátora',
        Operators: 'Operátori',
        Name: 'Meno',
    },

    Profile: {
        Profile: 'Profil',
        Name: 'Meno',
        Language: 'Jazyk',
        Password: 'Heslo',
        ConfirmPassword: 'Potvrdiť heslo',
        Update: 'Aktualizovať'
    },

    ResetPasswordForm: {
        NewPassword: 'Nové heslo',
        ConfirmPassword: 'Potvrdiť heslo',
        Submit: 'Odoslať'
    },

    InviteUserForm: {
        InviteHeader: 'Pozvaný uživatel',
        InviteText: 'Vyplňte prosím příslušné údaje a stiskněte Uložit, abyste se mohli přihlásit.',
        Name: 'Jméno',
        Language: 'Jazyk',
        NewPassword: 'Nové heslo',
        ConfirmPassword: 'Zopakujte nové heslo',
        Submit: 'Uložit'
    },

    TransactionList: {
        Type: 'Typ',
        Operator: 'Operátor',
        When: 'Kedy',
        Amount: 'Čiastka',
        Currency: 'Mena',
        Transactions: 'Transakcia',
        Device: 'Zariadenie',
        SalesDay: 'Den tržby',
        HoverDeposit: 'Zůstatek',
        HoverSalesIn: 'Vklad',
        HoverSalesOut: 'Výběr',
        HoverManualDeposit: 'Ruční vklad',
        HoverCollection: 'Odvod',
        HoverCollectionNotes: 'Odvod bankovek',
        HoverCollectionCoins: 'Odvod mincí',
        HoverCollectionEnvelope: 'Odvod ručního vkladu',
        HoverCollectionOK: 'Odvod potvrzený',
        HoverCollectionNotesOK: 'Odvod potvrzených bankovek',
        HoverCollectionCoinsOK: 'Odvod potvrzených mincí',
        HoverCollectionEnvelopeOK: 'Odvod potvrzených ručních vkladů',
        HoverCollectionNOK: 'Odvod diferencí',
        HoverCollectionNotesNOK: 'Odvod bankovek s diferencí',
        HoverCollectionCoinsNOK: 'Odvod mincí s diferencí',
        HoverCollectionEnvelopeNOK: 'Odvod ručních vkladů s diferencí',
        HoverDrain: 'Odstranění',
        HoverRefill: 'Naplnit',
        HoverExchange: 'Směna',
        HoverExchangeIn: 'Vybrat cizí měnu',
        HoverExchangeOut: 'Vložit cizí měnu',
        HoverCounterfeit: 'Padělky',
        HoverInternal: 'Vnitřní transakce',
        HoverNOP: 'Žádná operace'
    },

    TransactionDayList: {
        Date: "Datum",
        Sales: "Tržby",
        Pickup: "Výběr",
        Balance: "Zůstatek",
        TransactionDays: "Den transakce"
    },

    TransactionDay: {
        Date: "Datum",
        Sales: "Tržby",
        Pickup: "Výběr",
        Balance: "Zůstatek",
        TransactionDays: "Den transakce",
        ExportTransactions: "Exportovať transakcie",
    },

    TransactionDatePicker: {
        Date: 'Dátum'
    }
};


// WEBPACK FOOTER //
// ./src/lib/i18n/sk.js